import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconHeadsetOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M27 15.06v-1.32c0-6.08-4.92-11-11-11s-11 4.92-11 11v1.32c-.58.34-1 .96-1 1.7v4c0 .88.56 1.6 1.34 1.86a8.1 8.1 0 0 0 7.6 5.92c.3.42.78.72 1.36.72h3.42c.94 0 1.7-.76 1.7-1.7s-.76-1.7-1.7-1.7H14.3c-.56 0-1.02.28-1.34.68a6.13 6.13 0 0 1-5.66-4.3c.42-.36.7-.88.7-1.48v-4c0-.74-.42-1.34-1-1.7v-1.32c0-4.96 4.04-9 9-9s9 4.04 9 9v1.32c-.58.34-1 .96-1 1.7v4c0 1.1.9 2 2 2s2-.9 2-2v-4c0-.74-.42-1.34-1-1.7" /></svg>;
export default SvgIconHeadsetOutlined;